var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_vm.isLoading ? _c('div', {
    staticClass: "mb-2"
  }, [_vm._m(0), _c('div', {
    staticClass: "text-center"
  }, [_vm._v(" 載入中... ")])]) : _c('div', {
    staticClass: "earn-count"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.backgroundImage
    }
  }), _c('router-link', {
    staticClass: "earn-count__rules",
    attrs: {
      "to": {
        name: 'LiffProjAbbottAndLotteryRules',
        query: _vm.$route.query
      }
    }
  }, [_c('img', {
    staticClass: "rules-btn img-fluid",
    attrs: {
      "src": require("./images/earn-count-btn-rules.png")
    }
  })]), _c('span', {
    staticClass: "earn-count__count"
  }, [_vm._v(_vm._s(_vm.earnCount))]), _c('div', {
    staticClass: "earn-count__info"
  }, [_vm._m(1), _vm.lastSeasonHasEnded ? _c('router-link', {
    attrs: {
      "to": {
        name: 'LiffProjAbbottAndLotteryResult',
        query: {
          event_code: _vm.lastSeasonEventCode,
          from: _vm.$route.query.event_code
        }
      }
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.lastSeasonResultLinkImage
    }
  })]) : _c('router-link', {
    attrs: {
      "to": {
        name: 'LiffProjAbbottAndLotteryResult',
        query: {
          event_code: _vm.secondLastSeasonEventCode,
          from: _vm.$route.query.event_code
        }
      }
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.secondLastSeasonResultLinkImage
    }
  })])], 1)], 1)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "spinner-border text-primary",
    attrs: {
      "role": "status"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading...")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a', {
    attrs: {
      "href": "https://liff.line.me/1565710169-g0YZ75wA",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./images/earn-count-btn-1.png")
    }
  })]);
}]

export { render, staticRenderFns }